import { Dialog, Button, ButtonVariant, Size } from '@hourly-hds/components';
import { Alert } from '@hourly-hds/icons/colored';
import styles from './DeleteDialog.module.css';

const DeleteDocumentDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <div className={styles.overlayWrapper}>
      <Dialog
        open={isOpen}
        onClose={onClose}
        size={Size.Medium}
        aria-label="Delete Document Dialog"
        modal>
        <Dialog.Header>
          <header className={styles.header}>
            <Alert className={styles.headerIcon} />
            Delete Document
          </header>
        </Dialog.Header>
        <Dialog.Content>
          <p className={styles.contentDescription}>
            Are you sure you want to delete this document?
          </p>
        </Dialog.Content>
        <Dialog.Footer>
          <Button label="Cancel" onClick={onClose} />
          <Button variant={ButtonVariant.Primary} label="Confirm" onClick={onConfirm} />
        </Dialog.Footer>
      </Dialog>
    </div>
  );
};

export default DeleteDocumentDialog;
